<template lang="pug">
    .loaderWrapper
        .spinner.spinner--circle-2(:style="styles")
</template>

<script>
export default {
    props: {
        size: {
            default: "40px"
        },
        background: {
            default: "#ffa6a6"
        },
        color: {
            default: "#ff0000"
        },
        stroke: {
            default: "5px"
        }
    },
    computed: {
        styles() {
            return {
                width: this.size,
                height: this.size,
                border: this.stroke + " solid " + this.background,
                borderTopColor: this.color
            };
        }
    }
};
</script>

<style lang="stylus" scoped>

.loaderWrapper
    position: absolute
    top: 0
    left: 0
    display: flex
    width: 100%
    height: 100%
    justify-content: center
    align-items: center

.spinner
    box-sizing: border-box
    border-radius: 100%
    border: 10px solid rgba(255, 255, 255, 0.2)
    animation: circle-2-spin 1s infinite linear

@keyframes circle-2-spin
    100%
        transform: rotate(360deg)

</style>
